import React, { useEffect } from "react";
import { X } from "lucide-react";

function StandardModal({
  isOpen,
  onClose,
  title,
  subtitle,
  icon: Icon,
  children,
  isMobile,
  gradient = "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
  maxWidth = "700px",
}) {
  // Prevenir el shift del contenido cuando se oculta la scrollbar
  useEffect(() => {
    if (isOpen) {
      // Calcular el ancho de la scrollbar
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      // Aplicar overflow hidden y compensar con padding
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      // Restaurar valores originales
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    // Cleanup al desmontar
    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: isMobile ? "20px" : "40px",
        animation: "fadeIn 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "20px",
          width: "100%",
          maxWidth: isMobile ? "100%" : maxWidth,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          animation: "scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: gradient,
            color: "white",
            padding: isMobile ? "20px" : "25px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {Icon && <Icon size={24} />}
            <div>
              <h2
                style={{
                  margin: "0 0 5px 0",
                  fontSize: isMobile ? "18px" : "20px",
                  fontWeight: "700",
                }}
              >
                {title}
              </h2>
              {subtitle && (
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    opacity: 0.9,
                  }}
                >
                  {subtitle}
                </p>
              )}
            </div>
          </div>

          <button
            onClick={onClose}
            className="button-hover"
            style={{
              background: "rgba(255,255,255,0.2)",
              border: "none",
              borderRadius: "12px",
              padding: "8px 12px",
              color: "white",
              fontSize: "16px",
              cursor: "pointer",
              fontWeight: "600",
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              touchAction: "manipulation",
            }}
          >
            <X size={16} />
          </button>
        </div>

        {/* Contenido */}
        <div
          style={{
            flex: 1,
            padding: isMobile ? "20px" : "25px",
            overflowY: "auto",
            overflowX: "hidden", // Prevenir scroll horizontal
          }}
        >
          {children}
        </div>
      </div>


    </div>
  );
}

export default StandardModal; 